import { WhatsappIcon } from "assets";
import styles from "./styles.module.scss";

const Support = ({ text, message }: { text?: string; message?: string }) => {
  return (
    <>
      <a
        className={styles.whatsapp}
        href={`http://wa.me/2348031301167?text=${message}`}
        target="blank"
      >
        {text && <p>{text}</p>}
        <WhatsappIcon />
        
      </a>
    </>
  );
};

export { Support };
